import { Link, LinkProps } from 'react-router-dom';
import classNames from 'classnames';

export const TextLink = ({ className, ...rest }: LinkProps) => (
  <Link
    className={classNames(
      'underline text-teal-400 hover:text-teal-600 rounded-md',
      'focus:outline-none focus:ring focus:ring-offset-2',
      className
    )}
    {...rest}
  />
);
